module.exports = __webpack_public_path__ + "static/img/6a.061c583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6a.jpg
// module id = nxOZ
// module chunks = 0